module.exports = __webpack_public_path__ + "static/img/9.1c4f82a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/background/9.jpg
// module id = UFoa
// module chunks = 0